// src/components/Footer.tsx
import React from 'react';
import { Box, Container, Typography, Stack, Link, Divider } from '@mui/material';
import { Telegram, Description, Shield, HelpOutline, CopyrightOutlined, EmailOutlined, MenuBook } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
    return (
        <Box sx={{ bgcolor: '#1E293B', color: 'white', pt: 5, pb: 3 }}>
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={{ xs: 4, md: 6 }}
                    justifyContent="space-between"
                >
                    {/* Секция 1: Бренд и права */}
                    <Box sx={{ minWidth: 180 }}>

                        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mt: 1 }}>
                            <CopyrightOutlined sx={{ fontSize: 14, opacity: 0.5 }} />
                            <Typography variant="body2" sx={{ opacity: 0.5, fontSize: '0.8rem' }}>
                                2025–{new Date().getFullYear()} Typhon
                            </Typography>
                        </Stack>
                        <Typography variant="body2" sx={{ opacity: 0.4, fontSize: '0.75rem', mt: 0.5 }}>
                            Все права защищены
                        </Typography>
                    </Box>

                    {/* Секция 2: Документы */}
                    <Box>
                        <Typography
                            variant="overline"
                            sx={{ color: 'rgba(255,255,255,0.4)', letterSpacing: 2, fontSize: '0.7rem' }}
                        >
                            Документы
                        </Typography>
                        <Stack spacing={1.5} sx={{ mt: 1.5 }}>
                            <Link component={RouterLink} to="https://typhon.gitbook.io/docs" sx={{ color: 'rgba(255,255,255,0.65)', textDecoration: 'none', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: 0.75, '&:hover': { color: '#60A5FA' }, transition: 'color 0.2s' }}>
                                <MenuBook sx={{ fontSize: 15, opacity: 0.7 }} />
                                Документация
                            </Link>
                            <Link component={RouterLink} to="/terms" sx={{ color: 'rgba(255,255,255,0.65)', textDecoration: 'none', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: 0.75, '&:hover': { color: '#60A5FA' }, transition: 'color 0.2s' }}>
                                <Description sx={{ fontSize: 15, opacity: 0.7 }} />
                                Пользовательское соглашение
                            </Link>
                            <Link component={RouterLink} to="/privacy" sx={{ color: 'rgba(255,255,255,0.65)', textDecoration: 'none', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: 0.75, '&:hover': { color: '#60A5FA' }, transition: 'color 0.2s' }}>
                                <Shield sx={{ fontSize: 15, opacity: 0.7 }} />
                                Политика конфиденциальности
                            </Link>
                        </Stack>
                    </Box>

                    {/* Секция 3: Контакты */}
                    <Box>
                        <Typography
                            variant="overline"
                            sx={{ color: 'rgba(255,255,255,0.4)', letterSpacing: 2, fontSize: '0.7rem' }}
                        >
                            Контакты
                        </Typography>
                        <Stack spacing={1.5} sx={{ mt: 1.5 }}>
                            <Link href="https://t.me/tg_typhon_bot" target="_blank" rel="noopener" sx={{ color: '#60A5FA', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.75, '&:hover': { color: '#93C5FD' }, transition: 'color 0.2s' }}>
                                <Telegram sx={{ fontSize: 17 }} />
                                Наш бот
                            </Link>
                            <Link href="https://t.me/typhon_support" target="_blank" rel="noopener" sx={{ color: '#60A5FA', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.75, '&:hover': { color: '#93C5FD' }, transition: 'color 0.2s' }}>
                                <HelpOutline sx={{ fontSize: 17 }} />
                                Чат с поддержкой
                            </Link>
                            <Link href="https://t.me/tg_typhon" target="_blank" rel="noopener" sx={{ color: '#60A5FA', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.75, '&:hover': { color: '#93C5FD' }, transition: 'color 0.2s' }}>
                                <Telegram sx={{ fontSize: 17 }} />
                                Новостной канал
                            </Link>
                            <Link href="mailto:tgtyphon@yandex.ru" sx={{ color: 'rgba(255,255,255,0.65)', textDecoration: 'none', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: 0.75, '&:hover': { color: '#60A5FA' }, transition: 'color 0.2s' }}>
                                <EmailOutlined sx={{ fontSize: 16, opacity: 0.7 }} />
                                tgtyphon@yandex.ru
                            </Link>
                        </Stack>
                    </Box>
                </Stack>

                <Divider sx={{ borderColor: 'rgba(255,255,255,0.07)', mt: 4 }} />
            </Container>
        </Box>
    );
};

export default Footer;